/**
 * Quando a compra de um pacote é cobrada.
 *
 * Pacote não tem ciclo: ou cobra na hora, ou cobra pelo uso combinado. No
 * segundo caso a cobrança aparece na reserva do último dia agendado e vence no
 * dia seguinte — a data é fixada na compra e não se move se datas forem
 * acrescentadas depois.
 */
export interface PackageChargeSchedule {
  periodStartsOn: string;
  periodEndsOn: string;
  dueOn: string;
}

export interface PackageChargeInput {
  billingTiming: "start" | "end";
  purchasedOn: string;
  dates: string[];
}

function toUtcDate(value: string) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) throw new Error("invalid_calendar_date");
  return new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
}

function addDay(value: string) {
  const date = toUtcDate(value);
  date.setUTCDate(date.getUTCDate() + 1);
  return date.toISOString().slice(0, 10);
}

export function resolvePackageCharge({ billingTiming, purchasedOn, dates }: PackageChargeInput): PackageChargeSchedule {
  toUtcDate(purchasedOn);
  const sorted = [...dates].sort();
  const lastDate = sorted.length > 0 ? sorted[sorted.length - 1] : null;
  const periodEndsOn = lastDate ?? purchasedOn;

  return {
    periodStartsOn: purchasedOn,
    periodEndsOn,
    dueOn: billingTiming === "end" && lastDate ? addDay(lastDate) : purchasedOn,
  };
}
